// 앱 부트스트랩. data-site 테마 속성을 박고 pinia → router 순으로 초기화한다
import { createApp } from 'vue'
import { createAppRouter } from '@/app/router'
import { resolveSite } from '@/app/site'
import pinia from '@/stores'
import App from './App.vue'
import './styles/app.css'
import './styles/attendance.css' // 탭·매트릭스 그리드·통계카드 등 도메인 화면 공용 스타일(목업 포트)
import './styles/dashboard.css' // KPI·도메인카드·일일보고·공지 등 대시보드 공용 스타일(목업 포트)
import './styles/dailyreport.css' // 일일보고관리 통계카드·보고 양식 모달·인쇄 스타일(목업 포트)
import './styles/tailwind.css'

const site = resolveSite()
document.documentElement.dataset.site = site
const router = createAppRouter(site)

const app = createApp(App)
// 인증 가드가 store를 읽으므로 pinia를 router보다 먼저 등록해야 한다.
app.use(pinia)
app.use(router)
app.mount('#app')
